import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select", "output", "status", "downloadBtn"]

  connect() {
    this.offset = 0
    this.polling = false
    this.intervalId = null
    if (this.selectTarget.value) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  fileChanged() {
    this.stopPolling()
    this.offset = 0
    this.outputTarget.textContent = ''
    const file = this.selectTarget.value
    if (!file) {
      this.downloadBtnTarget.style.pointerEvents = 'none'
      this.downloadBtnTarget.style.opacity = '0.4'
      return
    }
    const downloadUrl = this.data.get('download-url')
    this.downloadBtnTarget.href = `${downloadUrl}?file=${encodeURIComponent(file)}`
    this.downloadBtnTarget.style.pointerEvents = ''
    this.downloadBtnTarget.style.opacity = ''
    this.startPolling()
  }

  startPolling() {
    if (this.polling) return
    this.polling = true
    this.statusTarget.textContent = 'In ascolto...'
    this.fetchContent()
    this.intervalId = setInterval(() => this.fetchContent(), 2000)
  }

  stopPolling() {
    this.polling = false
    clearInterval(this.intervalId)
    this.intervalId = null
    this.statusTarget.textContent = 'Fermo'
  }

  fetchContent() {
    const file = this.selectTarget.value
    if (!file) return

    const contentUrl = this.data.get('content-url')
    const url = `${contentUrl}?file=${encodeURIComponent(file)}&offset=${this.offset}`
    fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(r => r.json())
      .then(data => {
        if (data.error) {
          this.statusTarget.textContent = `Errore: ${data.error}`
          this.stopPolling()
          return
        }
        if (data.content && data.content.length > 0) {
          this.outputTarget.textContent += data.content
          this.outputTarget.scrollTop = this.outputTarget.scrollHeight
        }
        this.offset = data.offset
      })
      .catch(() => {
        this.statusTarget.textContent = 'Errore di rete'
      })
  }

  clearOutput() {
    this.outputTarget.textContent = ''
  }
}
